
import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";

interface Template {
  id: string;
  description: string;
  quantity: number;
  unit_price: number;
  currency: "EUR" | "GBP" | "USD";
}

interface LineItemCardProps {
  template: Template;
  onEdit: (template: Template) => void;
  onDelete: (id: string) => void;
}

export function LineItemCard({ template, onEdit, onDelete }: LineItemCardProps) {
  return (
    <div className="py-2 px-4 bg-white rounded-lg">
      <div className="grid grid-cols-[minmax(0,0.5fr),minmax(0,1fr),auto] gap-4 items-center">
        <h3 className="font-sm text-[#5E64A7] truncate text-left">{template.description}</h3>
        <h2 className="font-sm text-[#34375B] text-left">
          Total: {template.quantity * template.unit_price} {template.currency}
        </h2>
        <div className="flex gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onEdit(template)}
            className="text-[#636782] hover:text-[#34375B] hover:bg-transparent"
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDelete(template.id)}
            className="text-destructive text-[#F39D96] hover:text-[#F44336] hover:bg-transparent"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
